export default __webpack_public_path__ + "static/media/oneledger.5296149d.svg";